var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.beforeSaveItem.apply(null, arguments)
              },
              submit: function ($event) {
                $event.preventDefault()
                return _vm.beforeSaveItem.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("MapProperties", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "",
                  expression: "''",
                },
              ],
              attrs: {
                moduleCode: _vm.moduleCode,
                readonlyFormItem: _vm.readonlyFormItem,
                name: "map-properties",
              },
              model: {
                value: _vm.form.map,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "map", $$v)
                },
                expression: "form.map",
              },
            }),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
                showCancelButton: false,
              },
              on: {
                save: _vm.beforeSaveItem,
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`, true)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }